import React from 'react'

import useStyle from './style'

const ErrorUnauthorized = () => {
  const classes = useStyle()

  return (
    <div className={classes.wrapper}>
      <img alt="unauthorized" src="/public/images/unauthorized.png" />
    </div>
  )
}

export default ErrorUnauthorized
